require("bootstrap");
require("./app");

$(".in").on("click", function(e) {
    e.preventDefault();
    const target = $(this).attr("href");
    $(target).modal("show");
});
